import React from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';

const StatsCard = ({ extension, total, available, available_p, total_size }) => {
  const missing = total - available;
  const formattedPercentage =
    typeof available_p === 'number' ? `${available_p.toFixed(1)}%` : `${available_p}`;

  return (
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" fontWeight={600}>
            {extension.toUpperCase()}
          </Typography>
          <Typography variant="h6" fontWeight={600} color="primary">
            {formattedPercentage}
          </Typography>
        </Box>

        <Divider sx={{ mb: 1 }} />

        <Box>
          <StatItem label="Total" value={total} />
          <StatItem label="Available" value={available} color="success.main" />
          <StatItem label="Missing" value={missing} color="error.main" />
          <StatItem label="Total Size" value={total_size} unit="GB" color="text.secondary" />
        </Box>
      </CardContent>
    </Card>
  );
};

const StatItem = ({ label, value, unit, color }) => (
  <Box display="flex" justifyContent="space-between" my={0.5}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={500} color={color || 'text.primary'}>
      {value.toLocaleString()} {unit && <span>{` ${unit}`}</span>}
    </Typography>
    {/* {unit && (
      <Typography variant="body2" color="text.secondary">
        
      </Typography>
    )} */}
  </Box>
);

export default StatsCard;
